import useSWR from 'swr';
import api from 'api/api';
import { captureError } from '../sentry';
import { showTemporallyFeedback } from 'utils/userFeedback';
import { useDispatch } from 'react-redux';
import {
  actions as analyticsActions,
  constants as analyticsEvents,
} from 'state/analytics';
import { useMemo } from 'react';

export const useOrder = (orderId, isRecurring) => {
  const dispatch = useDispatch();
  const url = useMemo(() => {
    if (!orderId) {
      return null;
    }
    return isRecurring
      ? `recurring_orders/${orderId}/`
      : `shipper-app/shipper_orders/${orderId}/`;
  }, [isRecurring, orderId]);

  const { data, error, mutate } = useSWR(url, api.getInstance().get);

  if (error) {
    captureError('fetchingerror', error);
    showTemporallyFeedback(dispatch, {
      feedback: 'Orders:errors.generic',
      success: false,
    });
  }

  const order = data?.data;
  const loads = order?.shipments?.reduce(
    (current, shipment) => [...current, ...shipment.loads],
    []
  );

  return {
    order,
    loads,
    error,
    isLoading: !data,
    mutate,
  };
};

export const updateInternalReference = async ({
  internalReference,
  shipmentId,
}) => {
  return api.patch(`/shipments/${shipmentId}/`, {
    internal_reference: internalReference,
  });
};

export const updateAdditionalDocuments = async (
  { additionalDocuments, orderId },
  dispatch
) => {
  dispatch(
    analyticsActions.sendEvent(
      analyticsEvents.additionalDocuments.submit({
        orderId,
        numItems: (additionalDocuments || []).length,
      })
    )
  );
  try {
    return await api.patch(`/shipper_orders/${orderId}/additional_documents`, {
      additional_documents: additionalDocuments || [],
      need_to_be_printed: true,
    });
  } catch (err) {
    dispatch(
      analyticsActions.sendEvent(
        analyticsEvents.additionalDocuments.fail({ orderId })
      )
    );
    console.error('ERROR', err);
  }
};
